import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import GrayHeading from "../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import FileAttachment from "../../../../common/AdminCommonComponents/FileAttachment/FileAttachment"
import { useState } from "react"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import DynamicDropdown from "../../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"

const AddNewResource = ({ setAddNewResource }) => {
  const [file, setFile] = useState(null)

  const assignedToOptions = [{ label: "Seller" }, { label: "Admin" }]

  return (
    <>
      <div className="bg-white shadow px-4 p-3 mt-3">
        <ComponentBackButton onClick={() => setAddNewResource((prev) => !prev)} />
        <div className="d-flex justify-content-center">
          <GrayHeading>New Resource</GrayHeading>
        </div>

        <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <Row className="row-cols-1 row-cols-md-2">
            <Col>
              <Row className="g-0">
                <Col xs={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="resourceId">
                      Resource ID
                    </Label>
                    <Input id="resourceId" name="resourceId" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="type">
                      Type
                    </Label>
                    <Input id="type" name="type" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="assignedTo">
                      Assigned to
                    </Label>
                    <DynamicDropdown options={assignedToOptions} />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="g-0">
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="title">
                      Title
                    </Label>
                    <Input id="title" name="title" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="date">
                    Date
                    </Label>
                    <Input id="date" name="date" placeholder="" type="date" />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="attachment">
                      Attachment
                    </Label>
                    <FileAttachment id='attachment' setFile={setFile} />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-3 my-3">
            <DynamicButton theme="blue" outline>
              Cancel
            </DynamicButton>
            <DynamicButton theme="blue">Save</DynamicButton>
          </div>
        </Form>
      </div>
    </>
  )
}

export default AddNewResource
